//---------------angular staff---------------
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

//---------------pipes---------------
import { TranslateCutPipe } from './pipes/translateCut.pipe';

//---------------component---------------
import { FinalizeComponent } from './components/finalize/finalize.component';
import { InternationalPhoneComponent } from './components/internasional-phone/international-phone.component';

//---------------modules---------------
import { MaterialModule } from '../material.module';
import { PopupComponent } from './components/popup/popup.component';
import { GetTimeDatePipe } from './pipes/getTimeDate.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { SafePipe } from './pipes/safePipe.pipe';
import { SanitizeHtmlPipe } from './pipes/SanitizeHtmlPipe.pipe';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule, ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [TranslateCutPipe, FinalizeComponent, InternationalPhoneComponent,PopupComponent,GetTimeDatePipe,TruncatePipe,SafePipe,SanitizeHtmlPipe],
  exports: [TranslateCutPipe, FinalizeComponent, InternationalPhoneComponent,PopupComponent,GetTimeDatePipe,TruncatePipe,SafePipe,SanitizeHtmlPipe],
  entryComponents: [PopupComponent]
})
export class SharedModule { }
